import React, { useEffect, useState } from "react";
import { MapPinIcon } from "@heroicons/react/24/outline";
import CustomInputField from "../../../../customInputField";
import OfficePhotoUpload from "../../../../profileUpload/OfficePhotoUpload";
import { states } from "../../adminData";
import CustomStateDropdown from "../../../../dropdown/CustomStateDropDown";

const ProfessionalOfficeAddress = ({
  professionaInfo,
  handleChange,
  handleOfficePhotos,
  updatedImages,
  errorMessage,
}) => {
  const {
    officePhotos,
    office_address_1 = "",
    city = "",
    state = "",
    postal_code = "",
  } = professionaInfo || {};

  const [selectedOption, setSelectedOption] = useState();

  useEffect(() => {
    const found = states.find((st) => st.value === state);
    found && setSelectedOption(found);
  }, [state]);

  useEffect(() => {
    selectedOption &&
      handleChange({ target: { name: "state", value: selectedOption.value } });
  }, [selectedOption]);

  return (
    <div className="border border-solid border-[#EBEFF3] p-5 rounded-md mb-6 bg-white">
      <h5 className="text-base font-bold leading-[160%] text-customGray mb-4">
        Office Address
      </h5>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 relative mb-[22px] dark-field">
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            Office address
          </h6>
          <CustomInputField
            icon={MapPinIcon}
            placeHolder="Office Address"
            type="text"
            value={office_address_1}
            name="office_address_1"
            onChange={handleChange}
            classes="bg-white lg:h-[60px] flex items-center max-w-[626px] mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[50px] md:h-[70px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            city
          </h6>
          <CustomInputField
            icon={MapPinIcon}
            placeHolder="City"
            type="text"
            value={city}
            name="city"
            onChange={handleChange}
            classes="bg-white lg:h-[60px] flex items-center max-w-[626px] mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[50px] md:h-[70px] pr-[20px] bg-transparent"
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            state
          </h6>
          <CustomStateDropdown
            icon={MapPinIcon}
            options={states}
            classes="bg-white lg:h-[60px] flex items-center mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px]"
            textClasses="inline-flex w-full items-center lg:text-lg text-sm text-left gap-x-[10px] text-sm font-medium text-customGray placeholder:text-[#869099] h-full"
            leftIconClasses="icon w-6 h-6 text-customGray"
            rightIconClasses="-mr-1 h-6 w-6 text-[#485868] font-bold"
            menuClasses="scroller absolute left-0 z-10 mt-1 max-h-[180px] w-full origin-top rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  overflow-y-auto"
            setSelectedOption={setSelectedOption}
            selectedOption={selectedOption}
          />
        </div>
        <div>
          <h6 className="text-xs font-bold leading-[160%] text-[#869099] uppercase mb-2">
            ZIP Code
          </h6>
          <CustomInputField
            icon={MapPinIcon}
            placeHolder="90001"
            type="text"
            value={postal_code}
            name="postal_code"
            onChange={handleChange}
            classes="bg-white mb-0 lg:h-[60px] flex items-center max-w-[626px] mx-auto w-full border border-solid border-strokeColor rounded-[10px] h-[48px] overflow-hidden"
            inputClasses="border-r-0 lg:text-lg text-sm font-medium text-customGray placeholder:text-[#869099] pl-[10px] h-[50px] md:h-[70px] pr-[20px] bg-transparent"
          />
          {errorMessage && (
            <div className="text-red-500 text-xs leading-[160%] font-bold">
              {errorMessage}
            </div>
          )}
        </div>
      </div>
      <div>
        <h3 className="text-base font-bold leading-[160%] text-customGray capitalize">
          Office Photos{" "}
          <span className=" ml-[10px] text-sm font-normal leading-[160%] text-[#485868]">
            (Landscape photos are recommended, up to 6 allowed)
          </span>
        </h3>
        <OfficePhotoUpload
          photos={updatedImages ?? []}
          setUpdatedImages={handleOfficePhotos}
          isAdmin={true}
          user_id={professionaInfo?.id}
        />
      </div>
    </div>
  );
};

export default ProfessionalOfficeAddress;
